"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The SortenKontition model module.
 * @module model/SortenKontition
 * @version 1.0.44
 */
var SortenKontition = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SortenKontition</code>.
   * Kondition einer Sorte
   * @alias module:model/SortenKontition
   * @param kennziffer {String} Kennziffer der Sorte
   * @param bezeichnung {String} Bezeichnung der Sorte
   * @param soBpBuyKurs {Number} Kurs imVerkauf Shop
   * @param soBpSellKurs {Number} Kurs im Ankauf Shop
   * @param soWlBuyKurs {Number} Kurs der Sorte im Verkauf Kundenshop
   * @param soBpBuyKondition {Number} Konditionstyp bei Verkauf Shop
   * @param soBpSellKondition {Number} Konditionstyp bei Ankauf Shop
   * @param soWlBuyKondition {Number} Kondition im Verkauf Kundenshop
   */
  function SortenKontition(kennziffer, bezeichnung, soBpBuyKurs, soBpSellKurs, soWlBuyKurs, soBpBuyKondition, soBpSellKondition, soWlBuyKondition) {
    _classCallCheck(this, SortenKontition);
    SortenKontition.initialize(this, kennziffer, bezeichnung, soBpBuyKurs, soBpSellKurs, soWlBuyKurs, soBpBuyKondition, soBpSellKondition, soWlBuyKondition);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(SortenKontition, null, [{
    key: "initialize",
    value: function initialize(obj, kennziffer, bezeichnung, soBpBuyKurs, soBpSellKurs, soWlBuyKurs, soBpBuyKondition, soBpSellKondition, soWlBuyKondition) {
      obj['kennziffer'] = kennziffer;
      obj['bezeichnung'] = bezeichnung;
      obj['soBpBuyKurs'] = soBpBuyKurs;
      obj['soBpSellKurs'] = soBpSellKurs;
      obj['soWlBuyKurs'] = soWlBuyKurs;
      obj['soBpBuyKondition'] = soBpBuyKondition;
      obj['soBpSellKondition'] = soBpSellKondition;
      obj['soWlBuyKondition'] = soWlBuyKondition;
    }

    /**
     * Constructs a <code>SortenKontition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SortenKontition} obj Optional instance to populate.
     * @return {module:model/SortenKontition} The populated <code>SortenKontition</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SortenKontition();
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'String');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
        if (data.hasOwnProperty('soBpBuyKurs')) {
          obj['soBpBuyKurs'] = _ApiClient.default.convertToType(data['soBpBuyKurs'], 'Number');
        }
        if (data.hasOwnProperty('soBpSellKurs')) {
          obj['soBpSellKurs'] = _ApiClient.default.convertToType(data['soBpSellKurs'], 'Number');
        }
        if (data.hasOwnProperty('soWlBuyKurs')) {
          obj['soWlBuyKurs'] = _ApiClient.default.convertToType(data['soWlBuyKurs'], 'Number');
        }
        if (data.hasOwnProperty('soBpBuyKondition')) {
          obj['soBpBuyKondition'] = _ApiClient.default.convertToType(data['soBpBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('soBpSellKondition')) {
          obj['soBpSellKondition'] = _ApiClient.default.convertToType(data['soBpSellKondition'], 'Number');
        }
        if (data.hasOwnProperty('soWlBuyKondition')) {
          obj['soWlBuyKondition'] = _ApiClient.default.convertToType(data['soWlBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('soMaBuyKondition')) {
          obj['soMaBuyKondition'] = _ApiClient.default.convertToType(data['soMaBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('soMaBuyKurs')) {
          obj['soMaBuyKurs'] = _ApiClient.default.convertToType(data['soMaBuyKurs'], 'Number');
        }
        if (data.hasOwnProperty('changed')) {
          obj['changed'] = _ApiClient.default.convertToType(data['changed'], 'Boolean');
        }
        if (data.hasOwnProperty('soBpBuyChanged')) {
          obj['soBpBuyChanged'] = _ApiClient.default.convertToType(data['soBpBuyChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('soBpSellChanged')) {
          obj['soBpSellChanged'] = _ApiClient.default.convertToType(data['soBpSellChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('soMaBuyChanged')) {
          obj['soMaBuyChanged'] = _ApiClient.default.convertToType(data['soMaBuyChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('soWlBuyChanged')) {
          obj['soWlBuyChanged'] = _ApiClient.default.convertToType(data['soWlBuyChanged'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SortenKontition</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SortenKontition</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(SortenKontition.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['kennziffer'] && !(typeof data['kennziffer'] === 'string' || data['kennziffer'] instanceof String)) {
        throw new Error("Expected the field `kennziffer` to be a primitive type in the JSON string but got " + data['kennziffer']);
      }
      // ensure the json data is a string
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      return true;
    }
  }]);
}();
SortenKontition.RequiredProperties = ["kennziffer", "bezeichnung", "soBpBuyKurs", "soBpSellKurs", "soWlBuyKurs", "soBpBuyKondition", "soBpSellKondition", "soWlBuyKondition"];

/**
 * Kennziffer der Sorte
 * @member {String} kennziffer
 */
SortenKontition.prototype['kennziffer'] = undefined;

/**
 * Bezeichnung der Sorte
 * @member {String} bezeichnung
 */
SortenKontition.prototype['bezeichnung'] = undefined;

/**
 * Kurs imVerkauf Shop
 * @member {Number} soBpBuyKurs
 */
SortenKontition.prototype['soBpBuyKurs'] = undefined;

/**
 * Kurs im Ankauf Shop
 * @member {Number} soBpSellKurs
 */
SortenKontition.prototype['soBpSellKurs'] = undefined;

/**
 * Kurs der Sorte im Verkauf Kundenshop
 * @member {Number} soWlBuyKurs
 */
SortenKontition.prototype['soWlBuyKurs'] = undefined;

/**
 * Konditionstyp bei Verkauf Shop
 * @member {Number} soBpBuyKondition
 */
SortenKontition.prototype['soBpBuyKondition'] = undefined;

/**
 * Konditionstyp bei Ankauf Shop
 * @member {Number} soBpSellKondition
 */
SortenKontition.prototype['soBpSellKondition'] = undefined;

/**
 * Kondition im Verkauf Kundenshop
 * @member {Number} soWlBuyKondition
 */
SortenKontition.prototype['soWlBuyKondition'] = undefined;

/**
 * Mitarbeiterkondition bei Verkauf Shop
 * @member {Number} soMaBuyKondition
 */
SortenKontition.prototype['soMaBuyKondition'] = undefined;

/**
 * Kurs für Mitarbeiter im Verkauf Shop
 * @member {Number} soMaBuyKurs
 */
SortenKontition.prototype['soMaBuyKurs'] = undefined;

/**
 * Der Datensatz wurde geändert
 * @member {Boolean} changed
 */
SortenKontition.prototype['changed'] = undefined;

/**
 * soBpBuyKondition wurde geändert
 * @member {Boolean} soBpBuyChanged
 */
SortenKontition.prototype['soBpBuyChanged'] = undefined;

/**
 * soBpSellKondition wurde geändert
 * @member {Boolean} soBpSellChanged
 */
SortenKontition.prototype['soBpSellChanged'] = undefined;

/**
 * soMaBuyKondition wurde geändert
 * @member {Boolean} soMaBuyChanged
 */
SortenKontition.prototype['soMaBuyChanged'] = undefined;

/**
 * soWlBuyKondition wurde geändert
 * @member {Boolean} soWlBuyChanged
 */
SortenKontition.prototype['soWlBuyChanged'] = undefined;
var _default = exports.default = SortenKontition;